import { render, staticRenderFns } from "./ProfileAttentions.vue?vue&type=template&id=5150ff05&"
import script from "./ProfileAttentions.vue?vue&type=script&lang=js&"
export * from "./ProfileAttentions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5150ff05', component.options)
    } else {
      api.reload('5150ff05', component.options)
    }
    module.hot.accept("./ProfileAttentions.vue?vue&type=template&id=5150ff05&", function () {
      api.rerender('5150ff05', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/student-profile/components/attentions/ProfileAttentions.vue"
export default component.exports